import { Div } from '../../../../base/components/native/div'
import state from '../../../../base/services/state'
import services from '../../../../services'
import { Product } from '../../product/product'

export const ProductBlock = (productId = null, color: string = '') => {
    const [getProducts, setProducts] = state.use<any>('products')
    const base = Div()
    const title = Div('See your design on our products')
    const description = Div('We currently offer Mouse pads, T-shirts, Beanies and Hoodies...')
    const contents = Div()
    base.append(title, description, contents)

    title.cssClass({
        fontFamily: 'Syne',
        fontSize: '36px',
        fontWeight: '700',
        marginBottom: '26px',
    })
    description.cssClass({
        fontWeight: '400',
        fontSize: '18px',
        marginBottom: '26px',

    })
    contents.cssClass({
        overflowX: 'scroll',
        overflowY: 'hidden',
        scrollSnapStop: 'always',
        scrollSnapType: 'x mandatory',
        display: 'flex',
        backgroundColor: 'white',
        flexDirection: 'row',
    })

    base.cssClass({
        paddingTop: '30px',
        textAlign: 'center',
        backgroundColor: '#F7F7F7',
        // display: 'none',
    })

    return Object.assign(base, {
        async render() {
            contents.empty()
            let products = getProducts()
            if (!products) {
                products = await services.products.get()
                setProducts(products)
            }
            if (productId) {
                if (!products) return
                products = products.filter((product: any) => product.id === productId)
                contents.append(Product(products[0]))
            } else {
                if (!products) return
                products.forEach((product: any) => contents.append(Product(product)))
            }
        }
    })
}